import { Routes } from '@generouted/react-router/lazy'
import { createRoot } from 'react-dom/client'
import { instrument } from './next/lib/sentry'
import { initWebVitals } from './next/lib/web-vitals'

// Handle chunk loading failures (stale deployments) by auto-reloading
// This catches errors when users have outdated JS bundles after a deploy
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault()
  window.location.reload()
})

if (import.meta.env.PROD) instrument()
if (import.meta.env.DEV) initWebVitals()

createRoot(document.getElementById('root')!).render(<Routes />)
